import { render, staticRenderFns } from "./DashboardMain.vue?vue&type=template&id=1ecdd29b"
import script from "./DashboardMain.vue?vue&type=script&lang=ts"
export * from "./DashboardMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports